import { render, staticRenderFns } from "./UserCritical.vue?vue&type=template&id=295057ac"
import script from "./UserCritical.vue?vue&type=script&lang=js"
export * from "./UserCritical.vue?vue&type=script&lang=js"
import style0 from "./UserCritical.vue?vue&type=style&index=0&id=295057ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports